"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BreakLabel_component_exports = {};
__export(BreakLabel_component_exports, {
  default: () => BreakLabel_component_default
});
module.exports = __toCommonJS(BreakLabel_component_exports);
var import_react = __toESM(require("react"));
var import_useOnKeydown = require("../../../utils/useOnKeydown/useOnKeydown.hook");
var import_react_i18next = require("react-i18next");
var import_PageList = __toESM(require("./PageList.component"));
var import_BreakLabel = require("./BreakLabel.styled");
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
var BreakLabel = function BreakLabel2(_ref) {
  var currentPage = _ref.currentPage, totalPages = _ref.totalPages, marginPages = _ref.marginPages, pageRange = _ref.pageRange, onPageChange = _ref.onPageChange;
  var ref = (0, import_react.useRef)(null);
  var pageListRef = (0, import_react.useRef)(null);
  var _useState = (0, import_react.useState)(0), _useState2 = _slicedToArray(_useState, 2), start = _useState2[0], setStart = _useState2[1];
  var _useState3 = (0, import_react.useState)(0), _useState4 = _slicedToArray(_useState3, 2), end = _useState4[0], setEnd = _useState4[1];
  var _useState5 = (0, import_react.useState)(false), _useState6 = _slicedToArray(_useState5, 2), open = _useState6[0], setOpen = _useState6[1];
  var _useState7 = (0, import_react.useState)(null), _useState8 = _slicedToArray(_useState7, 2), pageListselected = _useState8[0], setPageListSelected = _useState8[1];
  var _useTranslation = (0, import_react_i18next.useTranslation)(), t = _useTranslation.t;
  (0, import_react.useEffect)(function() {
    var anchor = ref.current.parentNode;
    var listItem = anchor.parentNode;
    var list = listItem.parentNode;
    var index = Array.prototype.indexOf.call(list.childNodes, listItem);
    var totalItems = list.childNodes.length;
    var midMargin = Math.floor(pageRange / 2);
    var breakLabels = 2;
    var arrows = 2;
    var totalMarginPages = 2 * marginPages;
    var middlePages = 1 + 2 * midMargin;
    var maxItems = breakLabels + arrows + totalMarginPages + middlePages;
    var listHasTwoBreaks = totalItems === maxItems;
    var isFrontBreak = index < totalItems / 2;
    var isSmallBreak = pageRange === 0 && marginPages === 0;
    if (listHasTwoBreaks) {
      if (isFrontBreak) {
        setStart(2);
        setEnd(currentPage - midMargin);
      } else {
        setStart(currentPage + midMargin + 2);
        setEnd(totalPages - 1);
      }
    } else if (isFrontBreak && !isSmallBreak) {
      setStart(2);
      var endPage = totalPages - (totalItems - index - 2);
      if (currentPage + 1 >= 2 && currentPage + 1 <= endPage) {
        setEnd(currentPage - midMargin);
      } else {
        setEnd(endPage);
      }
    } else {
      if (isSmallBreak) {
        setStart(currentPage + midMargin + 2);
        setEnd(totalPages);
        return;
      }
      setStart(index);
      setEnd(totalPages - 1);
    }
  }, [currentPage, totalPages, marginPages, pageRange, setStart, setEnd]);
  var handleFocusonActive = function handleFocusonActive2() {
    var paginationList = ref.current.parentElement.parentElement.parentElement;
    var matches;
    setTimeout(function() {
      matches = paginationList.getElementsByClassName("active")[0].firstChild;
      matches.focus();
    }, 200);
  };
  var handleEvent = function handleEvent2(e) {
    var target = e.target;
    if (target.tagName === "LI") {
      setOpen(false);
      var page = Number(target.getAttribute("value"));
      handleFocusonActive();
      onPageChange({
        selected: page - 1
      });
    } else if (start === end) {
      onPageChange({
        selected: start - 1
      });
    } else {
      setOpen(function(prevOpen) {
        return !prevOpen;
      });
    }
  };
  var handleAnchorOnClick = function handleAnchorOnClick2(e) {
    e.preventDefault();
    e.stopPropagation();
    handleEvent(e);
  };
  var closePageListPopover = function closePageListPopover2() {
    setOpen(false);
    ref.current.focus();
  };
  var handleAnchorOnKeyDown = function handleAnchorOnKeyDown2(e) {
    switch (e.key) {
      case "Tab":
        break;
      case "Enter":
        e.preventDefault();
        handleEvent(e);
        break;
      case "Space":
        e.preventDefault();
        handleEvent(e);
        break;
      case "Escape":
        e.preventDefault();
        closePageListPopover();
        break;
      default:
        e.preventDefault();
    }
  };
  (0, import_react.useEffect)(function() {
    var anchor = ref.current.parentNode;
    anchor.addEventListener("click", handleAnchorOnClick);
    anchor.addEventListener("keydown", handleAnchorOnKeyDown);
    var spanInnerText = ref.current.innerHTML;
    var spanElement = ref.current;
    if (spanInnerText === "...") {
      spanElement.setAttribute("aria-expanded", "false");
    } else {
      spanElement.removeAttribute("aria-expanded");
    }
    return function() {
      anchor.removeEventListener("click", handleAnchorOnClick);
      anchor.removeEventListener("keydown", handleAnchorOnKeyDown);
    };
  }, [start, end]);
  var handleClickOutside = function handleClickOutside2(e) {
    if (!ref.current.parentNode.contains(e.target)) {
      setOpen(false);
    }
  };
  var setFocusOnList = function setFocusOnList2() {
    var _pageListRef$current;
    var pageListItems = (_pageListRef$current = pageListRef.current) === null || _pageListRef$current === void 0 ? void 0 : _pageListRef$current.querySelectorAll('li[role="menuitem"]');
    if (pageListItems[0]) {
      pageListItems[0].focus();
    }
  };
  (0, import_useOnKeydown.useOnKeydown)(pageListRef, function(event) {
    var _pageListRef$current2;
    var Escape = event.Escape, ArrowDown = event.ArrowDown, ArrowUp = event.ArrowUp;
    var currentPosition = pageListselected || 0;
    var pageListItems = (_pageListRef$current2 = pageListRef.current) === null || _pageListRef$current2 === void 0 ? void 0 : _pageListRef$current2.querySelectorAll('li[role="menuitem"]');
    if (Escape) {
      var _ref$current;
      if (pageListRef.current.scrollHeight > pageListRef.current.clientHeight) {
        pageListRef.current.scrollTop = 0;
      }
      closePageListPopover();
      (_ref$current = ref.current) === null || _ref$current === void 0 || (_ref$current = _ref$current.parentElement) === null || _ref$current === void 0 || _ref$current.focus();
    }
    if (ArrowDown && pageListItems.length > 0) {
      var pos = currentPosition + 1;
      if (pageListItems[pos]) {
        setPageListSelected(pos);
        pageListItems[pos].focus();
      }
    }
    if (ArrowUp && pageListItems.length > 0) {
      var _pos = currentPosition - 1;
      if (pageListItems[_pos]) {
        setPageListSelected(_pos);
        pageListItems[_pos].focus();
      }
    }
  });
  (0, import_useOnKeydown.useOnKeydown)(ref, function(event) {
    var Escape = event.Escape;
    if (Escape) {
      closePageListPopover();
    }
  });
  (0, import_react.useEffect)(function() {
    if (open) {
      setTimeout(function() {
        return setFocusOnList();
      }, 100);
    } else {
      document.addEventListener("mousedown", handleClickOutside);
      setPageListSelected(null);
    }
    return function() {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);
  (0, import_react.useEffect)(function() {
    var breakItemAnchorTag = ref.current.parentElement;
    breakItemAnchorTag.setAttribute("tabIndex", "0");
    breakItemAnchorTag.setAttribute("role", "presentation");
  }, []);
  var ariaLabel = t("base_constant_moreItems");
  var ariaLabelPopover = t("base_constant_moreItems");
  var display = "...";
  var className = "link";
  if (start === end) {
    ariaLabel = "".concat(t("base_glossary_page"), " ").concat(start);
    display = "".concat(start);
    className = "link node";
  }
  return /* @__PURE__ */ import_react.default.createElement(import_react.default.Fragment, null, /* @__PURE__ */ import_react.default.createElement("span", {
    role: "button",
    "data-testid": "Break-Label",
    ref,
    className,
    "aria-label": ariaLabel
  }, display), /* @__PURE__ */ import_react.default.createElement(import_BreakLabel.StyledPopover, {
    role: "dialog",
    offset: [0, 15],
    placement: "top",
    referenceElem: ref,
    isOpen: open,
    "aria-label": ariaLabelPopover
  }, /* @__PURE__ */ import_react.default.createElement(import_PageList.default, {
    start,
    end,
    ref: pageListRef
  })));
};
var BreakLabel_component_default = BreakLabel;
//# sourceMappingURL=BreakLabel.component.js.map